const STORAGE_KEY = 'cp.dashboard.lesson-view-mode.v1';

export type DashboardLessonViewMode = 'daily' | 'weekly' | 'timetable' | 'calendar';

export function readDashboardLessonViewMode(): DashboardLessonViewMode {
  if (typeof window === 'undefined') return 'daily';
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === 'weekly' || raw === 'daily' || raw === 'timetable' || raw === 'calendar') return raw;
  } catch {
    /* ignore */
  }
  return 'daily';
}

export function writeDashboardLessonViewMode(mode: DashboardLessonViewMode): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    /* ignore */
  }
}
